








import { defineComponent, useRoute } from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'BlankLayout',

  setup() {
    const route = useRoute();

    return {
      route,
    };
  },
});
